import { Component, OnInit } from '@angular/core';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { QFilterModel } from '../../../../models/qfilter.model';
import { TranslateService } from '@ngx-translate/core';
import { StoreCampaignService } from '../../../../services/store/stores-campaign.service';
import { Observable } from 'rxjs/Observable';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';

@Component({
  selector: 'app-shop-overview-trend',
  templateUrl: './shop-overview-trend.component.html',
  styleUrls: ['./shop-overview-trend.component.css']
})

// Pagina 21
export class ShopOverviewTrendComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  translations: any;
  public date_from: Date;
  public date_to: Date;
  public selectedStore: any;
  public data: QFilterModel;
  public datatable: Array<any>;

  constructor (
    private indicatorService: IndicatorsService,
    public srvStoreCampaign: StoreCampaignService,
    private searchModelFactory: SearchToolbarModelFactoryService,
    private svcAnalytics: AnalyticsService,
    private chartsService: IndicatorsChartService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.get([
      'stores.fatturato',
      'stores.fatturato_mq',
      'stores.incidenza_promo',
      'stores.num_clienti',
      'stores.penetrazione_loy',
      'stores.pdv',
      'stores.trend_fatturato',
      'stores.trend_clienti'
    ]).subscribe((t) => {
      this.translations = {
        fatturato: t['stores.fatturato'],
        fatturato_mq: t['stores.fatturato_mq'],
        incidenza_promo: t['stores.incidenza_promo'],
        num_clienti: t['stores.num_clienti'],
        penetrazione_loy: t['stores.penetrazione_loy'],
        pdv: t['stores.pdv'],
        trend_fatturato: t['stores.trend_fatturato'],
        trend_clienti: t['stores.trend_clienti']
      };
    });

  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;
    this.translate.get([
      'indicator.numero_negozi',
      'indicator.nuove_aperture',
      'indicator.fatturato',
      'indicator.fatturato_mq'
    ]).subscribe(t => {
      this.indicators = [];

      Observable.zip(this.indicatorService.indicatorCalculation('stores.Q071', this.data),
        this.indicatorService.indicatorCalculation('stores.Q072', this.data)).subscribe(
        (r) => {

          const indicators = [];

          r.forEach(function(rc) { rc.forEach(function(i) { indicators.push(i); }) });

          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'numero_negozi'), {dynamic: true, decimal_value: 0, decimal_prec_value: 0}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'nuove_aperture'), {dynamic: true, decimal_value: 0, decimal_prec_value: 0}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato'), {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
          this.indicators.push(new IndicatorBoxModel(indicators.filter((ind) => ind.name === 'fatturato_mq'), {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
        });
    });

    this.tableInit (data);
    this.show_results = true

  }

  public tableInit (data: QFilterModel) {

    Observable.zip(

      this.indicatorService.getChart ('stores.Q140B', data, false),
      this.indicatorService.getChart ('stores.Q140', data, false),
      this.indicatorService.getChart ('stores.Q141B', data, false),
      this.indicatorService.getChart ('stores.Q141', data, false),
      this.indicatorService.getChart ('stores.Q142B', data, false),
      this.indicatorService.getChart ('stores.Q142', data, false),

    ).subscribe(([Q140B, Q140, Q141B, Q141, Q142B, Q142]) => {

      this.datatable = [];

      let max     = Math.max (...Q140.series[9].serie);
      let min     = Math.min (...Q140.series[9].serie);
      let soglia  = (max - min) / 3;
      let soglia1 = soglia;
      let soglia2 = soglia * 2;

      let Q141Bseries = [];
      let Q141BseriesDate = [];
      for (let i = 0; i < Q141B.series[0].serie.length; i++) {
        let key = Q141B.series[0].serie[i];
        if (Q141Bseries.indexOf(key) === -1) {
          Q141Bseries[key] = [];
          Q141BseriesDate[key] = [];
        }
        Q141Bseries[key].push (Q141B.series[2].serie[i]);
        Q141BseriesDate[key].push (Q141B.series[1].serie[i]);
      }

      let Q142Bseries = [];
      let Q142BseriesDate = [];
      for (let i = 0; i < Q142B.series[0].serie.length; i++) {
        let key = Q142B.series[0].serie[i];
        if (Q142Bseries.indexOf(key) === -1) {
          Q142Bseries[key] = [];
          Q142BseriesDate[key] = [];
        }
        Q142Bseries[key].push (Q142B.series[2].serie[i]);
        Q142BseriesDate[key].push (Q142B.series[1].serie[i]);
      }

      let Q141series = [];
      let Q141seriesDate = [];
      for (let i = 0; i < Q141.series[0].serie.length; i++) {
        let key = Q141.series[0].serie[i];
        if (Q141series.indexOf(key) === -1) {
          Q141series[key] = [];
          Q141seriesDate[key] = [];
        }
        Q141series[key].push (Q141.series[2].serie[i]);
        Q141seriesDate[key].push (Q141.series[1].serie[i]);
      }

      let Q142series = [];
      let Q142seriesDate = [];
      for (let i = 0; i < Q142.series[0].serie.length; i++) {
        let key = Q142.series[0].serie[i];
        if (Q142series.indexOf(key) === -1) {
          Q142series[key] = [];
          Q142seriesDate[key] = [];
        }
        Q142series[key].push (Q142.series[2].serie[i]);
        Q142seriesDate[key].push (Q142.series[1].serie[i]);
      }

      let Q140Bserie0 = Q140B.series[0].serie;
      let Q140Bserie1 = Q140B.series[1].serie;
      let Q140Bserie3 = Q140B.series[3].serie;
      let Q140Bserie5 = Q140B.series[5].serie;
      let Q140Bserie7 = Q140B.series[7].serie;
      let Q140Bserie9 = Q140B.series[9].serie;
      for (let i = 0; i < Q140Bserie0.length; i++) {
        let trend_fatturatoB_chart = new LoyaltyChart('area');
        if (Q141Bseries.indexOf(Q140Bserie0[i]) !== -1) {
          trend_fatturatoB_chart.options.chart.height   = '100px';
          trend_fatturatoB_chart.options.chart.zoomType = 'xy';
          trend_fatturatoB_chart.options.xAxis          = {visible: false, categories: Q141BseriesDate[Q140Bserie0[i]]};
          trend_fatturatoB_chart.options.yAxis          = {visible: false};
          trend_fatturatoB_chart.options.legend         = {enabled: false};
          trend_fatturatoB_chart.options.tooltip        = {
            formatter: function() {
              return '<b>' + this.x + '</b>: ' + NumberKMPipe.formatDynamic(this.y, '€');
            }
          };
          trend_fatturatoB_chart.options.credits        = {enabled: false};
          trend_fatturatoB_chart.options.title          = {text: ''};
          trend_fatturatoB_chart.options.navigation     = {buttonOptions: {enabled: false}};
          trend_fatturatoB_chart.options.series         = [{data: Q141Bseries[Q140Bserie0[i]]}];
        } else {
          trend_fatturatoB_chart = null;
        }
        let trend_clientiB_chart = new LoyaltyChart('area');
        if (Q142Bseries.indexOf(Q140Bserie0[i]) !== -1) {
          trend_clientiB_chart.options.chart.height   = '100px';
          trend_clientiB_chart.options.chart.zoomType = 'xy';
          trend_clientiB_chart.options.xAxis          = {visible: false, categories: Q142BseriesDate[Q140Bserie0[i]]};
          trend_clientiB_chart.options.yAxis          = {visible: false};
          trend_clientiB_chart.options.legend         = {enabled: false};
          trend_clientiB_chart.options.tooltip        = {
            formatter: function () {
              return '<b>' + this.x + '</b>: ' + this.y;
            }
          };
          trend_clientiB_chart.options.credits        = {enabled: false};
          trend_clientiB_chart.options.title          = {text: ''};
          trend_clientiB_chart.options.navigation     = {buttonOptions: {enabled: false}};
          trend_clientiB_chart.options.series         = [{data: Q142Bseries[Q140Bserie0[i]]}];
        } else {
          trend_clientiB_chart = null;
        }
        let s = 'soglia-verde';
        if (Q140Bserie9[i] <= soglia1) {
          s = 'soglia-rossa';
        } else if (Q140Bserie9[i] <= soglia2) {
          s = 'soglia-gialla';
        }
        this.datatable.push ( {
          pdv:                Q140Bserie0[i],
          fatturato:          NumberKMPipe.formatDynamic(+Q140Bserie1[i]),
          trend_fatturato:    trend_fatturatoB_chart,
          fatturato_mq:       NumberKMPipe.formatDynamic(+Q140Bserie3[i]),
          incidenza_promo:    Q140Bserie5[i],
          num_clienti:        Q140Bserie7[i],
          trend_clienti:      trend_clientiB_chart,
          penetrazione_loy:   Q140Bserie9[i],
          class_soglia:       s
        } );
      }

      let Q140serie0 = Q140.series[0].serie;
      let Q140serie1 = Q140.series[1].serie;
      let Q140serie3 = Q140.series[3].serie;
      let Q140serie5 = Q140.series[5].serie;
      let Q140serie7 = Q140.series[7].serie;
      let Q140serie9 = Q140.series[9].serie;
      for (let i = 0; i < Q140serie0.length; i++) {
        let trend_fatturato_chart = new LoyaltyChart('area');
        if (Q141series.indexOf(Q140Bserie0[i]) !== -1) {
          trend_fatturato_chart.options.chart.height   = '100px';
          trend_fatturato_chart.options.chart.zoomType = 'xy';
          trend_fatturato_chart.options.xAxis          = {visible: false, categories: Q141seriesDate[Q140serie0[i]]};
          trend_fatturato_chart.options.yAxis          = {visible: false};
          trend_fatturato_chart.options.legend         = {enabled: false};
          trend_fatturato_chart.options.tooltip        = {
            formatter: function() {
              return '<b>' + this.x + '</b>: ' + NumberKMPipe.formatDynamic(this.y, '€');
            }
          };
          trend_fatturato_chart.options.credits        = {enabled: false};
          trend_fatturato_chart.options.title          = {text: ''};
          trend_fatturato_chart.options.navigation     = {buttonOptions: {enabled: false}};
          trend_fatturato_chart.options.series         = [{data: Q141series[Q140serie0[i]]}];
        } else {
          trend_fatturato_chart = null;
        }
        let trend_clienti_chart = new LoyaltyChart('area');
        if (Q142series.indexOf(Q140Bserie0[i]) !== -1) {
          trend_clienti_chart.options.chart.height   = '100px';
          trend_clienti_chart.options.chart.zoomType = 'xy';
          trend_clienti_chart.options.xAxis          = {visible: false, categories: Q142seriesDate[Q140serie0[i]]};
          trend_clienti_chart.options.yAxis          = {visible: false};
          trend_clienti_chart.options.legend         = {enabled: false};
          trend_clienti_chart.options.tooltip        = {
            formatter: function() {
              return '<b>' + this.x + '</b>: ' + this.y;
            }
          };
          trend_clienti_chart.options.credits        = {enabled: false};
          trend_clienti_chart.options.title          = {text: ''};
          trend_clienti_chart.options.navigation     = {buttonOptions: {enabled: false}};
          trend_clienti_chart.options.series         = [{data: Q142series[Q140serie0[i]]}];
        } else {
          trend_clienti_chart = null;
        }
        let s = 'soglia-verde';
        if (Q140serie9[i] <= soglia1) {
          s = 'soglia-rossa';
        } else if (Q140serie9[i] <= soglia2) {
          s = 'soglia-gialla';
        }
        this.datatable.push ( {
          pdv:                Q140serie0[i],
          fatturato:          NumberKMPipe.formatDynamic(+Q140serie1[i]),
          trend_fatturato:    trend_fatturato_chart,
          fatturato_mq:       NumberKMPipe.formatDynamic(+Q140serie3[i]),
          incidenza_promo:    Q140serie5[i],
          num_clienti:        Q140serie7[i],
          trend_clienti:      trend_clienti_chart,
          penetrazione_loy:   Q140serie9[i],
          class_soglia:       s
        } );
      }

    });
  }

  resetData() {
    this.show_results = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/store/panoramica/trend/shop-overview-trend.component.ts